module.exports = __webpack_public_path__ + "media/parents/happy-scholarship-winner-c8823a10.png";